var map = {
	"./bg-BG.json": 1963,
	"./ca-ES.json": 1964,
	"./cs-CZ.json": 1965,
	"./de-DE.json": 1966,
	"./el-GR.json": 1967,
	"./en-US.json": 988,
	"./es-ES.json": 1968,
	"./et-EE.json": 1969,
	"./fi-FI.json": 1970,
	"./fr-FR.json": 1971,
	"./he-IL.json": 1972,
	"./it-IT.json": 1973,
	"./ja-JP.json": 1974,
	"./ko-KR.json": 1975,
	"./nb-NO.json": 1976,
	"./nl-NL.json": 1977,
	"./nn-NO.json": 1978,
	"./pl-PL.json": 1979,
	"./pt-BR.json": 1980,
	"./ro-RO.json": 1981,
	"./ru-RU.json": 1982,
	"./sk-SK.json": 1983,
	"./sv-SE.json": 1984,
	"./tr-TR.json": 1985,
	"./zh-CN.json": 1986
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1962;